module.exports = __webpack_public_path__ + "img/ABP.55a10e9b.png";